
interface ThisProps {
  //  uidAuftrag: string;
}

/**
 * @author noone
 */
const AusschreibungComponent: React.FC<ThisProps> = () => {

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/files/AusschreibungVL2026.pdf"; // Pfad zur PDF im public-Ordner
    link.download = "AusschreibungVL2026.pdf";     // gewünschter Dateiname
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>

      <button className="btn btn-primary" onClick={handleDownload}>
        <i className="bi bi-download"></i> Download Ausschreibung als PDF Datei
      </button>
    </>
  );

}

export default AusschreibungComponent;